import axios from "axios";
import { apiBaseUrl } from "../../helpers/UrlHelper";
import { loginToken } from "../../helpers/LocalStorageHelper";

// Thin client for the portal-api Stripe-native billing endpoints
// (branch stripe-ground-zero). All auth:admin.
const request = (method, path, data) =>
  axios({
    url: apiBaseUrl(path),
    method,
    data,
    dataType: "json",
    headers: { Authorization: "Bearer " + loginToken() },
  });

export const fetchPlans = () => request("get", `admin/billing/plans`);

export const updatePlan = (id, payload) =>
  request("put", `admin/billing/plans/${id}`, payload);

export const upsertPrice = (id, payload) =>
  request("post", `admin/billing/plans/${id}/prices`, payload);

export const removePrice = (id, currency) =>
  request("delete", `admin/billing/plans/${id}/prices/${currency}`);

export const fetchSubscriptions = ({ status = "", q = "" } = {}) =>
  request(
    "get",
    `admin/billing/subscriptions?status=${encodeURIComponent(status)}&q=${encodeURIComponent(q)}`
  );

export const fetchPendingSites = () =>
  request("get", `admin/billing/pending-sites`);

// Org-scoped view of the slot model (feat/billing-slot-model) — the org's
// live subscription plus its per-plan slot breakdown (paid/live/free), in
// one call instead of fetching every org's subscriptions and filtering.
export const fetchOrgSlots = (organizationId) =>
  request("get", `admin/billing/organizations/${organizationId}/slots`);

// Super-admin idle-slot reduction — the "N paid slots / 0 sites" support
// exit. quantity is the number of free slots to remove (not the resulting
// total). Returns 422 if it would exceed the plan's free slot count.
export const reduceSlots = (organizationId, payload) =>
  request(
    "post",
    `admin/billing/organizations/${organizationId}/slots/reduce`,
    payload
  );

// The endpoints ship with portal-api `stripe-ground-zero`; until then the
// screens show a "not deployed yet" notice instead of an error wall.
export const isNotDeployed = (error) => {
  const s = error && error.response && error.response.status;
  return s === 404 || s === 405 || s === 501;
};

// unwrap either a bare array or the {data: [...]} / {data: {data: [...]}}
// envelopes this API uses elsewhere
export const unwrapList = (res) => {
  const d = res && res.data;
  if (Array.isArray(d)) return d;
  if (d && Array.isArray(d.data)) return d.data;
  if (d && d.data && Array.isArray(d.data.data)) return d.data.data;
  return [];
};

// unwrap the {status, data: {...}} envelope for single-object responses
export const unwrapObject = (res) => {
  const d = res && res.data;
  if (d && d.data && typeof d.data === "object") return d.data;
  return d || {};
};
